import { useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { StarRating, Badge } from "../ui/UI";
import CourseThumbnail from "./CourseThumbnail";
import { formatPrice, getDiscount } from "../../data/courses";
import styles from "./CourseCard.module.css";

const TAG_COLORS = {
  BESTSELLER: "gold",
  HOT:        "red",
  NEW:        "green",
  POPULAR:    "blue",
};

export default function CourseCard({ course, delay = 0 }) {
  const { addToCart, cart } = useApp();
  const navigate = useNavigate();
  const inCart = cart.some((c) => c.id === course.id);
  const disc   = getDiscount(course.originalPrice, course.price);

  const handleCardClick = () => navigate(`/course/${course.id}`);

  const handleCartClick = (e) => {
    e.stopPropagation(); // Don't navigate when clicking cart button
    addToCart(course);
  };

  return (
    <div
      className={styles.card}
      style={{ animationDelay: `${delay}ms` }}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleCardClick()}
    >
      {/* Thumbnail */}
      <CourseThumbnail thumbnail={course.thumbnail} title={course.title} size="card" />

      {/* Tags row — overlaid on thumbnail bottom */}
      <div className={styles.tagRow}>
        {course.tag && <Badge color={TAG_COLORS[course.tag] || "accent"}>{course.tag}</Badge>}
        <Badge color="green">{disc}% OFF</Badge>
      </div>

      <div className={styles.body}>
        <h3 className={styles.title}>{course.title}</h3>
        <p className={styles.subtitle}>{course.subtitle}</p>
        <StarRating rating={course.rating} count={course.reviews} />
        <span className={styles.pages}>📄 {course.pages} pages</span>
      </div>

      <div className={styles.footer}>
        <div className={styles.pricing}>
          <span className={styles.price}>{formatPrice(course.price)}</span>
          <span className={styles.originalPrice}>{formatPrice(course.originalPrice)}</span>
        </div>
        <button
          className={[styles.cartBtn, inCart ? styles.cartBtnAdded : ""].join(" ")}
          onClick={handleCartClick}
          disabled={inCart}
        >
          {inCart ? "✓ Added" : "+ Cart"}
        </button>
      </div>
    </div>
  );
}
